import type { Item } from 'bundles/learner-progress/types/Item';
import {
  getIsLockedByResit,
  getIsLockedForPremiumGrading,
  getIsLockedForSessions,
  getIsLockedFully,
} from 'bundles/learner-progress/utils/Item';

export function isItemLockedToAuditUpgradeFlowUsers(item: Item) {
  // what does "locked" even mean?  ¯\_(ツ)_/¯
  const isLocked = getIsLockedFully(item) || getIsLockedByResit(item) || getIsLockedForPremiumGrading(item);

  return (
    isLocked &&
    !item.isLockedByPreviousItem &&
    // `getIsLockedForSessions` checks for an item being locked from session preview and timed content
    // Upgrading from audit won't unlock these items because the lock is not tied to ownership
    !getIsLockedForSessions(item)
  );
}
